import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { PieChart, Pie, ResponsiveContainer, Legend } from 'recharts'
import { Title } from 'components/layout'
import { Actions, List } from 'components/misc'
import { apiActions, apiTasksOverview } from 'helpers/decorators/api'
import { meta } from 'helpers/decorators'

const data = [
  { name: 'Bronze', value: 98, fill: '#F5BE46' },
  { name: 'Silver', value: 43, fill: '#D8D8D8' },
  { name: 'Gold', value: 9, fill: '#F8E645' }
]

const data3 = [
  { name: 'Bronze', value: 59, fill: '#F5BE46' },
  { name: 'Silver', value: 30, fill: '#D8D8D8' },
  { name: 'Gold', value: 4, fill: '#F8E645' }
]

const data2 = [
  { name: 'Stand by', value: 2, fill: '#1295D1' },
  { name: 'Active', value: 98, fill: '#78D2F5' }
]

const data4 = [
  { name: 'Stand by', value: 10, fill: '#1295D1' },
  { name: 'Active', value: 76, fill: '#78D2F5' }
]

const RADIAN = Math.PI / 180

@meta({
  title: 'Dashboard',
  intlKey: 'pageTitle.dashboard'
})
@apiActions({
  list: true,
  loadOnMount: true
})
@apiTasksOverview({
  overview: true,
  cache: false
})
class Dashboard extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    tasks: PropTypes.object.isRequired
  }

  renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent
  }) => {
    const radius = (innerRadius + (outerRadius - innerRadius)) * 0.5
    const x = (cx + radius) * Math.cos(-midAngle * RADIAN)
    const y = (cy + radius) * Math.sin(-midAngle * RADIAN)

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    )
  }

  render() {
    const { tasks, actions } = this.props

    return (
      <div>
        <div className="row">
          <div className="col-xs-6">
            <Title
              h2
              className="delta reset--margin-top with-separator"
              intlKey="dashboard.your_todo_list"
            >
              Your To Do List
            </Title>
            <List data={tasks.overview.list} loading={tasks.loading} large />
          </div>
          <div className="col-xs-6">
            <Title
              h2
              className="delta reset--margin-top with-separator"
              intlKey="dashboard.while_you_were_gone"
            >
              While you were gone
            </Title>
            <Actions actions={actions.list} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Title
              h2
              className="delta reset--margin-top with-separator"
              intlKey="dashboard.charts"
            >
              Charts
            </Title>
            <div className="row">
              <div className="col-xs-6">
                <div className="row">
                  <div className="col-xs-6" style={{ height: 240 }}>
                    <Title
                      h4
                      style={{ margin: 0, textAlign: 'center' }}
                      intlKey="dashboard.participant_by_level"
                    >
                      Participant by level
                    </Title>
                    <ResponsiveContainer>
                      <PieChart
                        margin={{ top: 4, right: 4, bottom: 4, left: 4 }}
                      >
                        <Pie
                          data={data}
                          fill="#8884d8"
                          label={this.renderCustomizedLabel}
                          labelLine={false}
                        />
                        <Legend
                          verticalAlign="bottom"
                          iconSize={10}
                          layout="horizontal"
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="col-xs-6" style={{ height: 240 }}>
                    <Title
                      h4
                      style={{ margin: 0, textAlign: 'center' }}
                      intlKey="dashboard.leader_state"
                    >
                      Leaders state
                    </Title>
                    <ResponsiveContainer>
                      <PieChart
                        margin={{ top: 4, right: 4, bottom: 4, left: 4 }}
                      >
                        <Pie
                          data={data2}
                          fill="#8884d8"
                          label={this.renderCustomizedLabel}
                          labelLine={false}
                        />
                        <Legend
                          verticalAlign="bottom"
                          iconSize={10}
                          layout="horizontal"
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
              <div className="col-xs-6">
                <div className="row">
                  <div className="col-xs-6" style={{ height: 240 }}>
                    <Title
                      h4
                      style={{ margin: 0, textAlign: 'center' }}
                      intlKey="dashboard.award_approved_by"
                    >
                      Award approved by level in 2016
                    </Title>
                    <ResponsiveContainer>
                      <PieChart
                        margin={{ top: 4, right: 4, bottom: 4, left: 4 }}
                      >
                        <Pie
                          data={data3}
                          fill="#8884d8"
                          label={this.renderCustomizedLabel}
                          labelLine={false}
                        />
                        <Legend
                          verticalAlign="bottom"
                          iconSize={10}
                          layout="horizontal"
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="col-xs-6" style={{ height: 240 }}>
                    <Title
                      h4
                      style={{ margin: 0, textAlign: 'center' }}
                      intlKey="dashboard.type_of_awards"
                    >
                      Type of Awards Units
                    </Title>
                    <ResponsiveContainer>
                      <PieChart
                        margin={{ top: 4, right: 4, bottom: 4, left: 4 }}
                      >
                        <Pie
                          data={data4}
                          fill="#8884d8"
                          label={this.renderCustomizedLabel}
                          labelLine={false}
                        />
                        <Legend
                          verticalAlign="bottom"
                          iconSize={10}
                          layout="horizontal"
                        />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Dashboard
